<template>
  <div>
    <div class="content" v-if="!hidden">
      <div class="Combined-Shape">
      <ts-icon icon="info-rounded" size="large" color="#E7F5F6" title="Infos" slot="reference" />
      </div>
      {{this.message}}
      <button class="close" @click.prevent="hidden = true">&times;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertCommentBox',
  props: {
    message: {}
  },
  data() {
    return {
      hidden: false
    };
  },
  created() {
  }
};
</script>

<style scoped lang="scss">
.Combined-Shape {
  margin: 0 10px 0 0;
}
.close{
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 5px;
  font-size: 1.5rem;
}
.content {
  display: flex;
  position: relative;
  align-items: center;
  max-width: 64rem;
  margin: 20px auto;
  padding: 20px 33px 19px 20px;
  box-shadow: 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  // border: solid 2px rgba(182, 232, 188, 0.15);
  background: #D3E0E1;
  // background-blend-mode: soft-light, normal;
  // background-image: linear-gradient(275deg, #000, #fff 0%), linear-gradient(to bottom, rgba(25, 188, 142, 0.08), rgba(25, 188, 142, 0.08));
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6d7587;
  & b {
    font-weight: 600;
  }

}
</style>